import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["validationState", "variant", "className", "children", "dataContentPiece"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as m } from "react/jsx-runtime";
import n, { forwardRef as _ } from "react";
import { c as p } from "../../../clsx-OuTLNxxd.js";
const v = "Select-module_select__r1yFt",
  S = "Select-module_select-default__BVzJO",
  h = "Select-module_select-transparent__v3SQH",
  R = "Select-module_select-white__WKuAy",
  w = "Select-module_state-invalid__YwJE3",
  c = {
    select: v,
    selectDefault: S,
    selectTransparent: h,
    selectWhite: R,
    stateInvalid: w
  };
function y() {
  for (var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++) {
    s[_key] = arguments[_key];
  }
  const t = n.useRef(null);
  return n.useEffect(() => {
    s.forEach(e => {
      e && (typeof e == "function" ? e(t.current) : e.current = t.current);
    });
  }, [s]), t;
}
const W = (s, t) => {
    var r;
    const {
        validationState: e = void 0,
        variant: a = "default",
        className: o,
        children: u,
        dataContentPiece: i
      } = s,
      d = _objectWithoutProperties(s, _excluded),
      l = n.useRef(null),
      f = y(t, l);
    return /* @__PURE__ */m("select", _objectSpread(_objectSpread({
      ref: f
    }, d), {}, {
      "data-value": (r = l == null ? void 0 : l.current) == null ? void 0 : r.value,
      "aria-invalid": e == "error",
      className: p(o, c.select, {
        [c.selectDefault]: a == "default",
        [c.selectTransparent]: a == "transparent",
        [c.selectWhite]: a == "white",
        [c.stateInvalid]: e == "error"
      }),
      "data-content-piece": i,
      children: u
    }));
  },
  I = /* @__PURE__ */_(W);
export { I as Select };